import { getDefaultBrowser } from '@slardar/sdk-web';
import { createBrowserClient } from '../client';
import { npmPreCollect } from './npm-precollect';
var browserClient = createBrowserClient();
var win = getDefaultBrowser();
win && npmPreCollect(win, browserClient);
export default browserClient;
//# sourceMappingURL=npm.js.map